import * as yup from 'yup';

import { RoomStats } from 'models/index';

import { endpoint, EndpointError } from '../endpoint';
import { ERROR as VALIDATION_ERROR } from '../validation';

export type UpdateParams = Pick<RoomStats.IModel, 'roomId'> & Partial<Pick<RoomStats.IModel, 'totalReactions'>>;
export type UpdateResult = { data: undefined };
export type UpdateError = EndpointError;

export const updateSchema: yup.SchemaOf<UpdateParams> = yup.object().shape({
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  totalReactions: yup.number(),
});

export const update = endpoint<UpdateParams, UpdateResult, UpdateError>({
  method: 'POST',
  url: () => '/room-stats/update',
});
